import React, {useEffect} from 'react';
import {Form, Text} from 'react-aria-components';
import FullWidthLayout from "../../layouts/FullWidthLayout/FullWidthLayout.jsx";
import "./FilterCreate.css";
import {LuCog, LuMicroscope, LuWand2} from "react-icons/lu";
import {LabeledSection, LabeledTextField} from "../../components/Fields/LabeledTextField.jsx";
import DefaultButton, {WarningButton} from "../../components/Buttons/DefaultButton/DefaultButton.jsx";
import FilterActions, {
    conditionalActionValues,
    hideColumn,
    hideRow,
    renameColumn,
    replaceFieldWithFunction,
    replaceFieldWithStaticValue,
    unconditionalActionValues,
} from "../../components/FilterActions/FilterActions.jsx";
import DefaultDropButton from "../../components/Buttons/DefaultDropButton/DefaultDropButton.jsx";
import {Navigate, useParams} from "react-router-dom";
import api from "../../utils/api.js";
import DefaultMultiDropButton from "../../components/Buttons/DefaultMultiDropButton/DefaultMultiDropButton.jsx";
import LoadingLayout from "../../layouts/LoadingLayout/LoadingLayout.js";
import Toggle from "../../components/Toggle/Toggle.js";
import {FilterConditions} from "../../conditions/FilterConditionsList/FilterConditions.js";
import apiClient from "../../utils/api.js";
import {DatabaseResponse, FilterRequest, RoleResponse, TableResponse} from "../../utils/api-client/index.js";


function FilterCreate({
    returnTo,
    edit_id,
    defaultDatabases,
    defaultName,
    defaultDescription,
    defaultSelectedDatabase,
    defaultSelectedSchema,
    defaultSelectedTable,
    defaultSelectedRoles,
    defaultFilterType,
    defaultConditions,
    defaultActions,
    defaultUsers,
    pageTitle="Create Filter",
}:{
    returnTo?: string,
    edit_id?: string,
    defaultDatabases?: never,
    defaultName?: string,
    defaultDescription?: string,
    defaultSelectedDatabase?: never,
    defaultSelectedSchema?: never,
    defaultSelectedTable?: never,
    defaultSelectedRoles?: any[],
    defaultFilterType?: string,
    defaultConditions?: any[],
    defaultActions?: any[],
    defaultUsers?: never[],
    pageTitle: string
}) {
    if (defaultConditions === undefined) {
        defaultConditions = []
    }
    if (defaultActions === undefined) {
        defaultActions = []
    }
    if (defaultUsers === undefined) {
        defaultUsers = []
    }
    if (defaultSelectedRoles === undefined) {
        defaultSelectedRoles = []
    }

    const [submitting, setSubmitting] = React.useState(false)
    const [isLoading, setIsLoading] = React.useState(true)
    const [name, setName] = React.useState(defaultName)

    const [selectedDatabase, setSelectedDatabase] = React.useState<DatabaseResponse>(defaultSelectedDatabase)
    const [selectedRoles, setSelectedRoles] = React.useState<RoleResponse>(defaultSelectedRoles)
    const [selectedSchema, setSelectedSchema] = React.useState(defaultSelectedSchema)
    const [selectedTable, setSelectedTable] = React.useState<TableResponse>(defaultSelectedTable)

    const [databasesOptions, setDatabasesOptions] = React.useState([])
    const [schemaOptions, setSchemaOptions] = React.useState([])
    const [tableOptions, setTableOptions] = React.useState([])
    const [ColumnNames, setColumnNames] = React.useState([])

    const [conditions, setCondition] = React.useState(defaultConditions);
    const [actions, setActions] = React.useState(defaultActions);
    const [redirectTo, setRedirectTo] = React.useState(null)
    const [roles, setRoles] = React.useState(defaultSelectedRoles)
    const [conditionally, setConditionally] = React.useState(defaultConditions.length === 0 ? "unconditional" : "conditional")
    const {id} = useParams()

    if(id !== null && id !== undefined){
        returnTo = `/database/${id}`
    }
    const equals = "Field Equals a Value"
    const notEquals = "Field Does Not Equal a Value"
    const contains = "Field Contains a Value"
    const notContains = "Field Does Not Contain a Value"
    const greaterThan = "Field is Greater Than a Value"
    const lessThan = "Field is Less Than a Value"
    const greaterThanOrEquals = "Field is Greater Than or Equals a Value"
    const lessThanOrEquals = "Field is Less Than or Equals a Value"

    const conditionValues = [equals, notEquals, contains, notContains, greaterThan, lessThan, greaterThanOrEquals, lessThanOrEquals]

    useEffect(() => {
        api.listDatabases().then(Databases => {
            setDatabasesOptions(Databases)
            if (!defaultSelectedDatabase) {
                setIsLoading(false)
            }
        })


        api.getDatabase(id).then(db => {
            setSelectedDatabase(db)
            setIsLoading(false)
        })
    }, []);

    useEffect(() => {
        if (!selectedDatabase) {
            return
        }
        setRoles(selectedDatabase.roles)
        setSelectedRoles(selectedDatabase.roles)

        let newSchemaOptions = []
        selectedDatabase.tables.forEach((table) => {
            newSchemaOptions.push(table.tableSchema)
        })

        newSchemaOptions.sort()
        newSchemaOptions = [...new Set(newSchemaOptions)]
        newSchemaOptions = newSchemaOptions.filter(schema => schema !== "pg_catalog")
        newSchemaOptions = newSchemaOptions.filter(schema => schema !== "information_schema")
        if (newSchemaOptions.length === 0) {
            newSchemaOptions.push("public")
            newSchemaOptions.push("pg_catalog")
            newSchemaOptions.push("information_schema")
        }
        if (newSchemaOptions.length === 3) {
            setTimeout( () => {
                api.getDatabase(id).then(db => {
                    setSelectedDatabase(db)
                })
            }, 1000)
        }
        setSchemaOptions(newSchemaOptions)

        if (newSchemaOptions.length === 1 && !selectedSchema) {
            setSelectedSchema(newSchemaOptions[0])
        }

    }, [selectedDatabase]);

    useEffect(() => {
        if (!selectedSchema) {
            setTableOptions([])
            return
        }
        const newTableOptions = []
        selectedDatabase.tables.forEach((table) => {
            if (table.tableSchema === selectedSchema) {
                newTableOptions.push(table.name)
            }
        })
        setTableOptions(newTableOptions)
        if (newTableOptions.length === 1 && !selectedTable) {
            onTableSelect(newTableOptions[0])
        }
    }, [selectedSchema]);

    useEffect(() => {
        if (selectedDatabase === undefined || selectedTable === undefined) {
            return
        }

        if (selectedTable?.columns.length > 0) {
            const newColumnNames = []
            selectedTable.columns.forEach((column) => {
                newColumnNames.push(column.columnName)
            })
            setColumnNames(newColumnNames)
            return
        }

        apiClient.getDatabase(selectedDatabase.id).then((db) => {
            setSelectedDatabase(db)
            if (selectedTable) {
                const newColumnNames = []
                db.tables.forEach((table) => {
                    if (table.name === selectedTable.name) {
                        table.columns.forEach((column) => {
                            newColumnNames.push(column.columnName)
                        })
                    }
                })
                setColumnNames(newColumnNames)
            }
        })

    }, [selectedTable]);


    if (isLoading || submitting) {
        return <LoadingLayout />
    }

    if(redirectTo){
        return <Navigate to={redirectTo} />
    }

    if (selectedSchema && tableOptions && tableOptions.length === 0) {
        onSchemaSelect(selectedSchema)
    }


    const DatabaseNames = []
    if(databasesOptions){
        databasesOptions.forEach((Database) => {
            DatabaseNames.push(Database.name)
        })
    }

    function onSchemaSelect(schemaName){
        setSelectedSchema(schemaName)
        const newTableOptions = []
        selectedDatabase.tables.forEach((table) => {
            if(table.name === schemaName){
                setSelectedTable(null)
            }
            if(table.tableSchema === schemaName){
                newTableOptions.push(table.name)
            }
        })
        setTableOptions(newTableOptions)
    }

    function onTableSelect(tableName){
        selectedDatabase.tables.forEach((table) => {
            if(table.name === tableName){
                setSelectedTable(table)
            }
        })
    }

    function onNameChange(e){
        setName(e.target.value);
    }

    function addEqualsCondition() {
        setCondition([...conditions, {
            field: null,
            operator: "==",
            value: null
        }]);
    }

    function addNotEqualsCondition() {
        setCondition([...conditions, {
            field: null,
            operator: "!=",
            value: null
        }]);
    }

    function addContainsCondition(){
        setCondition([...conditions, {
            field: null,
            operator: "contains",
            value: null,
        }])
    }

    function addNotContainsCondition(){
        setCondition([...conditions, {
            field: null,
            operator: "not contains",
            value: null,
        }])
    }

    function addGreaterThanCondition(){
        setCondition([...conditions, {
            field: null,
            operator: "greater than",
            value: null,
        }])
    }

    function addLessThanCondition(){
        setCondition([...conditions, {
            field: null,
            operator: "less than",
            value: null,
        }])
    }

    function addGreaterThanOrEqualsCondition(){
        setCondition([...conditions, {
            field: null,
            operator: "greater than or equals",
            value: null,
        }])
    }

    function addLessThanOrEqualsCondition(){
        setCondition([...conditions, {
            field: null,
            operator: "less than or equals",
            value: null,
        }])
    }


    function addHideRowAction(){
        setActions([...actions, {
            action: hideRow,
        }])
    }

    function addHideFieldAction(){
        setActions([...actions, {
            action: hideColumn,
            fieldName: null,
        }])
    }

    function addRenameColumnAction(){
        setActions([...actions, {
            action: renameColumn,
            fieldName: null,
            newName: null,
        }])
    }

    function addStaticValueAction(){
        setActions([...actions, {
            action: replaceFieldWithStaticValue,
            fieldName: null,
            valueType: null,
            value: null,
        }])
    }

    function addFunctionAction(){
        setActions([...actions, {
            action: replaceFieldWithFunction,
            fieldName: null,
            functionName: null,
        }])
    }

    async function save() {

        const selectedRoleIds = []
        if (selectedRoles) {
            selectedRoles.forEach((role) => {
                selectedRoleIds.push(role.id)
            })
        }

        let newActions = []
        actions.forEach(action => {
            if (action.valueType === "json" || action.value_type === "json") {
                action.value = JSON.stringify(action.value)
            }
            newActions.push(action)
        })
        const body: FilterRequest = {
            name: name,
            description: "",
            server: selectedDatabase ? selectedDatabase.id : null,
            schema: selectedSchema ? selectedSchema : null,
            table: selectedTable ? selectedTable.id : null,
            conditions: conditions,
            actions: newActions,
            role_ids: selectedRoleIds,
        };
        setSubmitting(true)
        if (edit_id){
            await api.updateFilter(edit_id, body).then((data) => {
                if (data){
                    if(returnTo){
                        setRedirectTo(returnTo)
                    } else {
                        setRedirectTo(`/database/${selectedDatabase.id}`)
                    }
                } else {
                    console.error("Error updating filter")
                }
                setSubmitting(false)
            })
        } else {
            await api.createFilter(body).then((response) => {
                if(response===undefined){
                    return
                }
                if(returnTo){
                    setRedirectTo(returnTo)
                } else {
                    setRedirectTo("/filters")
                }
            }).catch(e => {
                console.error("Error creating filter: ", e)
            })
            setSubmitting(false)
        }

    }

    const customButtonStyle = {
        width:"185px",
        float:"right",
    }

    const conditionsInputs = <>
        <LabeledSection
            label="When (conditions)"
            icon={<LuMicroscope/>}
        >
            <div>
                <Text className="secondary1">When the following conditions are met: </Text>
                <DefaultDropButton
                    name="addCondition"
                    buttonText="Add Condition"
                    options={conditionValues}
                    label="Add Condition"
                    hideLabel
                    customStyle={customButtonStyle}

                    onSelect={(value) => {
                        if (value === equals) {
                            addEqualsCondition();
                        }
                        if (value === notEquals) {
                            addNotEqualsCondition();
                        }
                        if (value === contains) {
                            addContainsCondition();
                        }
                        if (value === notContains) {
                            addNotContainsCondition();
                        }
                        if (value === greaterThan) {
                            addGreaterThanCondition();
                        }
                        if (value === lessThan) {
                            addLessThanCondition();
                        }
                        if (value === greaterThanOrEquals) {
                            addGreaterThanOrEqualsCondition();
                        }
                        if (value === lessThanOrEquals) {
                            addLessThanOrEqualsCondition();
                        }
                    }}
                    errorLoc={[]}
                />
            </div>
            <FilterConditions
                conditions={conditions}
                setConditions={setCondition}
                columnNames={ColumnNames}
            />
        </LabeledSection>
    </>

    const selectedRoleNames = selectedRoles.map(role => {return role.name})

    const content = <>
        <Form action="/filter/create" method="post" className="filter-create">
            <LabeledSection label="General" icon={<LuCog/>} className="general-settings">
                <LabeledTextField
                    label="Filter Name"
                    name="filterName"
                    placeholder="Filter Name"
                    onChange={onNameChange}
                    value={name}
                    errorLoc={["body", "name"]}
                    hiddenLabel={undefined}
                />
                <DefaultMultiDropButton
                    name="roles"
                    label="Apply to Roles"
                    emptyText={(selectedRoles.length > 0) ? selectedRoles.map(role => role.name).join(", ") : "Select roles to apply filter"}
                    className="roles"
                    errorLoc={["body", "role_ids"]}
                    options={roles ? roles.map(role => {return role.name}) : []}
                    selected={selectedRoleNames}
                    onSelect={(selected) => {
                        const newSelectedRoles = []
                        roles.forEach((role) => {
                            if(selected.includes(role.name)){
                                newSelectedRoles.push(role)
                            }
                        })
                        setSelectedRoles(newSelectedRoles)
                    }}
                />
                { schemaOptions.length === 1 ? null : <DefaultDropButton
                    label="Schema"
                    name="schema"
                    buttonText={selectedSchema?"Select a schema": null}
                    options={schemaOptions}
                    selected={selectedSchema ? selectedSchema : null}
                    onSelect={onSchemaSelect}
                    errorLoc={["body", "schema"]}
                /> }
                <DefaultDropButton
                    label="Table"
                    name="table"
                    buttonText="Select a table"
                    options={tableOptions}
                    selected={selectedTable ? selectedTable.name : null}
                    onSelect={onTableSelect}
                    errorLoc={["body", "table"]}
                />
                <Toggle
                    choices={[
                        "unconditional",
                        "conditional"
                    ]}
                    selected={conditionally}
                    onSelect={(value) => {
                        if (value !== conditionally) {
                            setCondition([])
                            setActions([])
                        }
                        setConditionally(value)
                    }}
                    label={"Conditionally"}
                />
            </LabeledSection>
            { conditionally === "conditional" ? conditionsInputs : null}
            { selectedTable ? <LabeledSection label="Action(s)" icon={<LuWand2/>}>
                <div>
                    {/*<Text className="secondary1">Then the following actions are triggered: </Text>*/}
                    <DefaultDropButton
                        name="addAction"
                        buttonText="Add Action"
                        options={conditionally === "conditional" ? conditionalActionValues : unconditionalActionValues}
                        label="Add Action"
                        hideLabel
                        errorLoc={[]}
                        customStyle={customButtonStyle}

                        onSelect={(value) => {
                            if (value === hideRow) {
                                addHideRowAction();
                            } else if (value === hideColumn) {
                                addHideFieldAction();
                            } else if (value === renameColumn) {
                                addRenameColumnAction();
                            } else if (value === replaceFieldWithStaticValue) {
                                addStaticValueAction();
                            } else if (value === replaceFieldWithFunction) {
                                addFunctionAction();
                            } else {
                                console.error("Unknown action: ", value);
                            }
                        }}
                    />
                </div>
                <FilterActions
                    actions={actions}
                    setActions={setActions}
                    columnNames={ColumnNames}
                />
            </LabeledSection> : null}
            <div className="buttons">
                <DefaultButton
                    className="actionButton"
                    text="Save Filter"
                    onPress={save}
                    href={undefined}
                    oneClick
                />
                <WarningButton
                    className="actionButton second"
                    text="Cancel and Exit"
                    onPress={async () => {
                        if(returnTo){
                            setRedirectTo(returnTo)
                        } else {
                            setRedirectTo(`/database/${selectedDatabase.id}`)
                        }
                    }}
                    href={undefined}
                    oneClick
                />
            </div>
        </Form>
    </>

    return <FullWidthLayout
        title={pageTitle}
        mainContent={content}
        actionButton={undefined}
    />
}

export default FilterCreate
